import Logout from '@mui/icons-material/Logout'
import Print from '@mui/icons-material/Print'
import { Button } from '@mui/material'
import { useEffect, useState } from 'react'
import {
  PrescriptionFooterButton,
  PrescriptionFooterContainer,
  PrescriptionFooterCustomizedButton,
} from './styledComponents'

export default function PrescriptionFooterComponent({
  goToPrintPage,
  endConsultation,
  onPrescriptionPreviewPage,
  timeElapsedInSeconds,
  setTimeElapsedInSeconds,
  sidebarSelectMenu,
  sidebarSelectedMenuItem,
  setSidebarSelectedMenuItem,
}) {
  const [timeElapsedInSecondsInHeader, setTimeElapsedInSecondsInHeader] =
    useState(timeElapsedInSeconds)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeElapsedInSecondsInHeader((prev) => prev + 1)
    }, 1000)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  function leaveRoom() {
    setTimeElapsedInSeconds(timeElapsedInSecondsInHeader)
    endConsultation()
  }

  function getInitialsForAString(string) {
    let initials = string.match(/\b\w/g) || []
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase()
    return initials
  }

  return (
    <PrescriptionFooterContainer items={sidebarSelectMenu?.length + 2}>
      <PrescriptionFooterButton
        variant="text"
        color="error"
        sx={{ flexDirection: 'column', alignItems: 'center', borderRadius: '0px !important' }}
        onClick={leaveRoom}
      >
        <Logout sx={{ margin: '0!important' }} />
        <span>Exit</span>
      </PrescriptionFooterButton>
      {sidebarSelectMenu?.map((item, index) => (
        <PrescriptionFooterCustomizedButton
        color="emrSecondary"
          variant={item?.id === sidebarSelectedMenuItem ? 'contained' : 'text'}
          selected={item?.id === sidebarSelectedMenuItem}
          sx={{
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '0px !important',
            ...(item?.id === sidebarSelectedMenuItem
              ? {}
              : {
                  color: '#000',
                  backgroundColor: 'transparent',
                }),
          }}
          key={index}
          onClick={() => {
            setSidebarSelectedMenuItem(item?.id)
          }}
        >
          <span className="fw-bold" style={{ letterSpacing: '3px' }}>
            {getInitialsForAString(item?.label)}
          </span>
          <span>{item?.label}</span>
        </PrescriptionFooterCustomizedButton>
      ))}
      {/* <div>
        
          style={{
            textAlign: 'center',
            cursor: 'pointer',
            fontWeight: item?.id === sidebarSelectedMenuItem ? '600' : '400',
            color: item?.id === sidebarSelectedMenuItem ? '#FFF' : '#EFEFEF',
          }}
        >
          
        </div> */}
      {!onPrescriptionPreviewPage && (
        <PrescriptionFooterButton
          variant="text"
          sx={{ flexDirection: 'column', alignItems: 'center', borderRadius: '0px !important' }}
          color="success"
          onClick={goToPrintPage}
        >
          <Print sx={{ margin: '0!important' }} />
          <span>Preview</span>
        </PrescriptionFooterButton>
      )}
    </PrescriptionFooterContainer>
  )
}
